import { canDownloadEntities } from 'containers/decorators';
import DownloadDropdown from 'components/DownloadDropdown';
import Button from 'components/UIKit/Button/ButtonTemplate';
import DownloadIcon from 'components/icons/DownloadIcon';
import { Spinner } from 'components/UIKit/Spinner';

const QCErrorDownloadContainer = ({
  count,
  children,
  download,
  isDownloading,
  formats,
}) => (
  <DownloadDropdown
    disabled={(typeof count === 'number' && count < 1) || isDownloading}
    download={download}
    formats={formats}
    >
    <Button
      data-testid="button-download-qc-report"
      disabled={(typeof count === 'number' && count < 1) || isDownloading}
      PrefixComponent={isDownloading
        ? <Spinner style={{ width: '14px', height: '14px', margin: '0 0.25rem' }} />
        : <DownloadIcon />}
      >
      {children || 'Download QC Report'}
    </Button>
  </DownloadDropdown>
);

export default canDownloadEntities(QCErrorDownloadContainer);
